<form [formGroup]="confirmPasswordForm">
  <div class="row">
    <div class="col-md-6">
      <mat-form-field floatLabel='always' class="label-overflow">
        <mat-label>{{label}}</mat-label>
        <input (keyup)="transformFn(confirmPasswordForm.get('password'),field_obj.transform);checkValidity()" matInput
          formControlName="password" [type]="type && type.type1 ? type.type1 : 'text'"
          [required]="required ? true :false" [maxlength]="maxlength" [minlength]="minlength" />
        <mat-hint>
          <ng-container
            *ngIf="confirmPasswordForm.errors && confirmPasswordForm.errors.passwordNotMatch && (confirmPasswordForm.get('confirmpassword').touched)">
            <div class="text-red">
              {{label}} value is mismatched
            </div>
          </ng-container>
          <ng-template #patternnum>
            <div class="text-red"
              *ngIf="confirmPasswordForm && (confirmPasswordForm.get('password').hasError('pattern'))">
              {{'Invalid input'}}
            </div>
          </ng-template>
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field floatLabel='always'>
        <mat-label>Confirm {{label}}</mat-label>
        <input (keyup)="transformFn(confirmPasswordForm.get('password'),field_obj.transform);checkValidity()" matInput
          formControlName="confirmpassword" [type]="type && type.type2 ? type.type2 : 'text'"
          [required]="required ? true :false" />
      </mat-form-field>
    </div>

    <div class="col-md-12">
      <!-- {{this.form.value[this.controlName]}} -->
      <!-- {{(confirmPasswordForm.get('password').touched) && (confirmPasswordForm.get('password').dirty)}}
            {{(confirmPasswordForm.get('confirmpassword').touched) && (confirmPasswordForm.get('confirmpassword').dirty)}}
            {{confirmPasswordForm.errors && confirmPasswordForm.errors.passwordNotMatch &&
            (confirmPasswordForm.get('password').touched) && (confirmPasswordForm.get('confirmpassword').touched)}} -->

      <!-- <ng-template #maxlengthnum>
                <mat-error *ngIf="form_group && form_group.get(field_obj.fieldID).hasError('maxlength');else minlengthnum">
                    Maximum length ({{field_obj.UIValidationObjStruct.max_length.value || 999999999}}) has exceeded
                </mat-error>
            </ng-template>
            <ng-template #minlengthnum>
                <mat-error *ngIf="form_group && form_group.get(field_obj.fieldID).hasError('minlength'); else maxvaluenum">
                    Minimum length must be ({{field_obj.UIValidationObjStruct.min_length.value || 0}})
                </mat-error>
            </ng-template>
            <ng-template #maxvaluenum>
                <mat-error *ngIf="form_group && form_group.get(field_obj.fieldID).hasError('max');else minvaluenum">
                    Value must be lesser than {{field_obj.max}}
                </mat-error>
            </ng-template>
            <ng-template #minvaluenum>
                <mat-error *ngIf="form_group && form_group.get(field_obj.fieldID).hasError('min'); else patternnum">
                    Value must be greater than {{field_obj.min}}
                </mat-error>
            </ng-template>
            <ng-template #patternnum>
                <mat-error *ngIf="form_group && form_group.get(field_obj.fieldID).hasError('pattern')">
                    {{'Invalid input'}}
                </mat-error>
            </ng-template> -->

      <!-- <span>

            </span> -->
    </div>
  </div>
</form>